<template>
   <div class="filtro">
      <Forms ref="searchOcurrences"
                  :title="'Busca por Chamado'"
                  :showHelp="false"
                  :showClearButtonIcon="true"
                  :ShowFooterImbo="true"
                  :showSearchIcon="true"
                  :Minimize="true"
                  :showSearchButtonIcon="true"
                  @changeMinizado="$emit('changeMinizado')"
                  v-on:Clear="Clear"
                  v-on:Search="Search"
                  v-on:Load="onLoad"
         >
            <div>
               <b-form-group>
                  <div style="display: flex; flex-direction: column; gap:1rem; height: 100%">
                  <div v-if="!hasRole(roles.RW_REAL_ESTA_USER_OBRA)">
                     <label class="labelsearch">Status do Chamado</label>
                     <select v-model="formSearch.StatusChamados" name="statusChamado" class="form-control" id="exampleFormControSelect2">
                        <option :value="null" disabled>Todos os Status</option>
                        <option v-for="data in statusocorrencia" v-bind:key="data.value" :value="data.value">{{data.text}}</option>
                     </select>
                  </div>
                  <div>
                     <label for="txtInsured" class="labelsearch">Nome do Morador</label>
                     <input v-model="formSearch.Nome" placeholder="Digite o Nome do Morador" class="form-control" />
                  </div>
                  <div>
                     <label class="labelsearch">Empreendimento</label>
                     <select v-model="formSearch.EmpreendimentoNovaUnidadeId" name="statusChamado" class="form-control" id="exampleFormControSelect2">
                        <option :value="null" disabled>Selecione um Empreendimento</option>
                        <option v-for="data in dataempreendimento" :key="data.id" :value="data.id">{{data.nomeEmpreendimento}}</option>
                     </select>
                  </div>
                  <div>
                     <label class="labelsearch">Unidade</label>
                     <autocomplete-z ref="UnidadeTypeahead"
                        placeholder="Digite uma unidade"
                        iconClass="fas fa-city"
                        :serializer="(unidade) => unidade.nomeUnidade"
                        :debounceLength="3"
                        :formField="Unidade"
                        v-on:search="onSearchUnidade"
                        v-on:changeCode="onChangeCodeCidade"
                        :ShowCode="false"
                      />
                  </div>
                  <div>
                     <label class="labelsearch">Causa Raiz</label>
                     <select v-model="formSearch.CausaRaiz" name="statusChamado" class="form-control" id="exampleFormControSelect2">
                        <option :value="null" disabled>Selecione a Causa Raiz</option>
                        <option v-for="data in CausaRaiz" :key="data.id" :value="data.value">{{data.text}}</option>
                     </select>
                  </div>
                  <div>
                     <label class="labelsearch">Patologia</label>
                     <select v-model="formSearch.Patologia" name="statusChamado" class="form-control" id="exampleFormControSelect2">
                        <option :value="null" disabled>Selecione uma Patologia</option>
                        <option v-for="data in patologias" :key="data.id" :value="data.value">{{data.text}}</option>
                     </select>
                  </div>
                  <!-- <div>
                     <label class="labelsearch">Técnico Responsável</label>
                     <autocomplete-z ref="tecnicoTypeahead"
                     placeholder="Digite Nome do Técnico"
                     :serializer="(tecnico) => tecnico.nome"
                     :debounceLength="3"
                     :formField="TecnicoId"
                     v-on:search="onSearchTechnician"
                     :ShowCode="false"
                     />
                  </div> -->
                  <div>
                        <div class="dateOcurrence">
                           <label class="labeldate">Data do Chamado</label>
                        <div class="d-flex justify-content-between align-items-center dateFilter">
                           <div style="width: 100%;">
                              <label class="labeldate-ate">Desde</label>
                              <input type="date" v-model="formSearch.DataStartChamado" class="input-date form-control" />
                           </div>
                           <div style="width: 100%;">
                              <label class="labeldate-ate">Até</label>
                              <input type="date" v-model="formSearch.DataFimChamado" class="input-date form-control"  />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               </b-form-group>
            </div>
            <template #slotminimized>
               <div @click="$emit('changeMinizado')" class="container-minimizado">
                  <div class="panel-minimizado">
                     <i class="fas fa-search mt-3"></i>
                  </div>
                  <div class="iconeminizado">
                     <i class="fas fa-arrow-right"></i>
                  </div>
               </div>
            </template>
      </Forms>
   </div>
</template>
<script>
import searchocurrence from './searchocurrence'
export default searchocurrence
</script>
<style scoped>

:deep(.container-fluid) {
   height: 100%;
}

.margem{
  margin-bottom: 35.2%;
}
.panel-minimizado{
   height: 75vh;
   width: 85%;
   background: #eceff1;
   font-size: 20px;
   color: #008148;
   display: flex;
   align-items: center;
   flex-direction: column;
   border-radius: 10px;
   border: 1px solid #d8d8d8;
}
.container-minimizado{
   position: relative;
}
.labelsearch{
  font-weight: bold;
  color: #666666;
  font-size: 14px;
  margin-bottom: 5px;
  padding-bottom: 0px;
  font-family: 'Segoe UI';
  /* margin:10px 0; */
}
.iconeminizado{
   position: absolute;
   height: 50px;
   background: #008148;
   border-radius: 50%;
   display: flex;
   justify-content: center;
   font-size: 25px;
   align-items: center;
   cursor: pointer;
   color: white;
   top: 45%;
   right: 2%;
   width: 50px;
}

#text{
  font-size: 70px;
}

#app.zopone .text-third{
  font-size: 16px;
}

.datainicio{
   padding: 0;
}
.input-date{
   width: 100% !important;
}

.entredata{
   margin: 0 5px;
    display: flex;
    align-items: flex-end;
    font-size: 16px;

}
.labelseach{
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: bold
}

.labeldate{
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  font-family: 'Segoe UI';
}

.labeldate-ate{
   margin-bottom: 10px;
   font-size: 14px;
   color: #666666;
   font-family: 'Segoe UI';
}

.dateFilter{
      width: 100%;
      display: flex;
      font-weight: bold;
      gap: 0.3rem;
      flex-direction: column;
   }

@media(max-width: 1280px) {
}

@media (max-width: 1600px) {
   .dateOcurrence{
      width: 100%;
      display: flex;
      flex-direction: column;
   }

   .dateFilter{
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 0.3rem;
   }
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/searchocurrence/searchocurrence.vue